import { render, staticRenderFns } from "./AddDataList.vue?vue&type=template&id=2d3f8f2b&scoped=true&"
import script from "./AddDataList.vue?vue&type=script&lang=js&"
export * from "./AddDataList.vue?vue&type=script&lang=js&"
import style0 from "./AddDataList.vue?vue&type=style&index=0&id=2d3f8f2b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3f8f2b",
  null
  
)

export default component.exports